export enum TypeMode {
    Edit = 'edit',
    Create = 'create'
}